import { render, staticRenderFns } from "./addAcquiring.vue?vue&type=template&id=59f72ef0"
import script from "./addAcquiring.vue?vue&type=script&lang=js"
export * from "./addAcquiring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports